import instance from "api/globalaxios";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import isEmpty from "lodash/isEmpty";
import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getCaseAnonymous } from "slices/casesSlice";
import { getCompanyFlowsAnonymous } from "slices/companyFlowsSlice";
import { getDisputeAnonymous } from "slices/disputeSlice";
import SingleDispute from "./SingleDispute";
import { isMuthoot } from "Routes/Routes";

export default function SingleDisputeContainer() {
  const dispatch = useDispatch();
  const disputeId = sessionStorage.getItem("disputeId");
  const email = sessionStorage.getItem("email");
  const phone = sessionStorage.getItem("phone_number");

  function getUserProfile(email, phone) {
    const e = email === "" ? null : email;
    return async (dispatch) => {
      try {
        const response = await instance.get(
          `/api/userappointmentprofilelistanonymous/${null}/${e}/${null}` + ((isMuthoot && phone) ? `/${phone}` : "")
        );
        return response.data.profiles[0];
      } catch (error) {
        console.log(error);
      }
    };
  }

  const [profile, setprofile] = useState();
  const [profileLoading, setProfileLoading] = useState(true);
  React.useEffect(() => {
    dispatch(getUserProfile(email, phone)).then((res) => {
      setprofile(res);
      setProfileLoading(false);
    });
  }, []);

  const {
    // profile: { profile, loading: profileLoading },
    disputes: { loading: disputeLoading, activeDispute: activeDispute },
    cases: { loading: caseLoading, activeCase: activeCase },
    companyFlows: { loading: companyFlowsLoading, companyFlows },
  } = useSelector((state) => state, shallowEqual);

  React.useEffect(() => {
    dispatch(getDisputeAnonymous(disputeId, email, phone));
    dispatch(getCaseAnonymous(disputeId, email, phone));
    dispatch(getCompanyFlowsAnonymous());
  }, []);

  const passObjects = {
    profile,
    activeDispute,
    activeCase,
    companyFlows,
  };
  const loading =
    profileLoading ||
    caseLoading ||
    disputeLoading ||
    companyFlowsLoading ||
    isEmpty(activeDispute) ||
    isEmpty(activeCase);

  if (!loading) return <SingleDispute {...passObjects} />;
  else return <CircularCenteredLoader />;
}
